// Fallback for old/buggy WebViews where Intl.Segmenter is missing or not constructible.
(function applyIntlSegmenterFallback() {
  const g = typeof globalThis !== 'undefined'
    ? globalThis
    : (typeof window !== 'undefined' ? window : this);

  if (!g) {
    return;
  }

  if (!g.Intl) {
    g.Intl = {};
  }

  let segmenterWorks = false;
  try {
    if (typeof g.Intl.Segmenter === 'function') {
      const probe = new g.Intl.Segmenter('en', { granularity: 'grapheme' });
      const it = probe.segment('ok');
      segmenterWorks = !!it && typeof it[Symbol.iterator] === 'function';
    }
  } catch (e) {
    segmenterWorks = false;
  }

  if (segmenterWorks) {
    return;
  }

  function FallbackSegmenter() {
    if (!(this instanceof FallbackSegmenter)) {
      return new FallbackSegmenter();
    }
  }

  FallbackSegmenter.prototype.segment = function segment(input) {
    const text = String(input == null ? '' : input);
    const chars = Array.from(text);

    return {
      [Symbol.iterator]: function* iterator() {
        let index = 0;
        for (let i = 0; i < chars.length; i++) {
          const ch = chars[i];
          yield {
            segment: ch,
            index,
            input: text,
            isWordLike: true,
          };
          index += ch.length;
        }
      }
    };
  };

  try {
    g.Intl.Segmenter = FallbackSegmenter;
  } catch (e) {
    // Ignore: if assignment is blocked, app will continue with existing Intl.
  }
})();
